import {ComponentType, lazy} from 'react'

/**
 * Wraps React.lazy so that a ChunkLoadError (stale bundle referencing a
 * chunk hash that no longer exists on the server after a new deploy)
 * triggers a single full page reload instead of a permanent blank/error page.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{default: T}>
) {
  return lazy(async () => {
    const storageKey = 'chunk-reload-' + factory.toString()
    try {
      const module = await factory()
      sessionStorage.removeItem(storageKey)
      return module
    } catch (error) {
      const alreadyReloaded = sessionStorage.getItem(storageKey) === 'true'
      if (!alreadyReloaded) {
        sessionStorage.setItem(storageKey, 'true')
        window.location.reload()
        return new Promise(() => {})
      }
      throw error
    }
  })
}
